module.exports = __webpack_public_path__ + "media/images/close2-5f7c176f.png";